<docs>
# Checkbox

> NOTE: this docs defined at **docs** section inside Checkbox.vue module

Checkbox UI Set


<!-- STORY -->

### Example

>Single

```javascript
<template>
  <div>
    <mt-checkbox id="item-0" label="checked item" v-model="checked1"  />
    <mt-checkbox id="item-1" label="checked item" v-model="checked2"  />
  </div>
</template>
<script>
  export default {
    data() {
      return {
        checked1: false,
        checked2: true
      };
    }
  };
</script>
```

>Indeterminate

```html
<div class="indeterminate-checkbox">
  <mt-checkbox id="item-0" label="checked item" v-model="indeterminateModel" type="indeterminate"/>
</div>
```

>Group

```html
<mt-checkbox class="group-checkbox" v-for="item in items" :key="item" :label="item" v-model="item.checked" />
```

>Disabled

```html
<mt-checkbox id="item-0" label="disabled checked item" :checked="true" :disabled="true"  />
<mt-checkbox id="item-1" label="disabled unchecked item" :checked="false" :disabled="true"  />
```

>Event

```javascript
<template>
  <mt-checkbox id="item-3" label="checked item" v-model="checked3" @change="handleChange" />
</template>
<script>
  export default {
    data() {
      return {
        checked3: false,
      };
    },
    methods: {
      handleChange(value, event){
        console.log('change', value, event)
      }
    }
  };
</script>
```



### Props

| Property           | Description         | Type           | Accepted Values       | Default     |
|--------------------|---------------------|----------------|-----------------------|-------------|
| id                 | id of item          | String/Number  | —                     | —           |
| label              | label of item       | String         | —                     | —           |
| checked            | Whether or checked  | Boolean        | —                     | false       |
| disabled           | Whether or disabled | Boolean        | —                     | false       |
| type               | Whether or type     | String         | —                     | normal      |

### Events

| Name         | Description                       | Parameters |
|--------------|-----------------------------------|------------|
| click        | fire when checked value clicked.  | event      |
| change       | fire when checked value changed.  | value, event      |

</docs>
<template>
  <label :for="id" class="mt-checkbox" :class="type === 'indeterminate' ? 'mt-checkbox--indeterminate' : ''">
    <input type="checkbox"
      :id="id"
      v-model="selfModel"
      @click="handleClick"
      @change="handleChange"
      :disabled="disabled"/>
    <span class="line"></span>
    <span class="label">
      <slot></slot>
      <template v-if="!$slots.default">{{label}}</template>
    </span>
  </label>
</template>

<script>
export default {
  name: 'mt-checkbox',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
    },
    id: [String, Number],
    type: {
      type: String,
      default: 'normal'
    }
  },
  components: {

  },
  data () {
    return {
      selfModel: false,
    }
  },
  computed: {

  },

  methods: {
    handleClick(evt){
      this.$emit('click', evt)
    },
    handleChange(evt){
      this.$emit('change', this.selfModel, evt)
    }
  },

  mounted(){
    this.selfModel = this.checked
  },

  watch: {
    checked: function(val) {
      this.selfModel = val
    }
  }

}
</script>
<style src="./Checkbox.scss" lang="scss">
</style>



// WEBPACK FOOTER //
// Checkbox.vue?2bf9072c